import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  emailList: Yup.array()
    .of(Yup.string().email('Must be valid email addresses'))
    .min(1, 'Please enter at least one email'),
  enteredEmail: Yup.string().email('Please enter a valid email address'),
});
